import React, { useState, useEffect } from 'react'
import { Badge } from 'antd'

function NotificationIcon({ onClick }) {
    const [hasNewNotifications, setHasNewNotifications] = useState(
        localStorage.getItem('hasNewNotifications') === 'true'
    )

    useEffect(() => {
        const handleNewNotification = () => {
            setHasNewNotifications(true)
        }

        window.addEventListener('newNotification', handleNewNotification)
        return () => window.removeEventListener('newNotification', handleNewNotification)
    }, [])

    const handleClick = (e) => {
        setHasNewNotifications(false)
        localStorage.setItem('hasNewNotifications', 'false')
        // Don't stop event propagation to allow Popover to work
        onClick && onClick(e)
    }

    return (
        <Badge dot={hasNewNotifications} offset={[-2, 2]}>
            <span className="gx-topbar-icon gx-icon-notify gx-pointer" onClick={handleClick}>
                <svg viewBox="0 0 24 24" fill="none">
                    <path d="M12 3a5 5 0 0 0-5 5v3.2c0 .6-.2 1.2-.6 1.7L5 15.5c-.7.9-.1 2.2 1 2.2h12c1.1 0 1.7-1.3 1-2.2l-1.4-1.6c-.4-.5-.6-1-.6-1.7V8a5 5 0 0 0-5-5Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
                    <path d="M10 20a2 2 0 0 0 4 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
            </span>
        </Badge>
    )
}

export default NotificationIcon